export const getVideoThumbnail = async (file: File): Promise<File> => {
  return new Promise((resolve, reject) => {
    const video = document.createElement("video");
    const canvas = document.createElement("canvas");
    video.autoplay = true;
    video.muted = true;
    video.src = URL.createObjectURL(file);

    video.onloadeddata = () => {
      video.currentTime = 1; // Set to 1 second
    };

    video.ontimeupdate = () => {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.getContext("2d")?.drawImage(video, 0, 0);

      canvas.toBlob((blob) => {
        if (blob) {
          const thumbnailFile = new File([blob], `${file.name}-thumbnail.jpg`, { type: "image/jpeg" });
          URL.revokeObjectURL(video.src);
          resolve(thumbnailFile);
        } else {
          reject(new Error("Failed to create thumbnail"));
        }
      }, "image/jpeg");
    };

    video.onerror = () => {
      URL.revokeObjectURL(video.src);
      reject(new Error("Error loading video"));
    };
  });
};
